export default {
  props: {
    disabled: {
      description: 'A flag to disable the input',
      type: Boolean,
      default: false,
    },
  },
};
